import { render, staticRenderFns } from "./ChangeShipDateDialog.vue?vue&type=template&id=36b3fc64"
import script from "./ChangeShipDateDialog.vue?vue&type=script&lang=js"
export * from "./ChangeShipDateDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeShipDateDialog.vue?vue&type=style&index=0&id=36b3fc64&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports